import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { BRAND_LOGO_URL } from '../../themes.constants';

export const InCorporationWithCoop = (): ReactElement => (
  <Container>
    <Logo alt="Storebrand logo" src={BRAND_LOGO_URL.storebrandWhite} />
  </Container>
);

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
`;

const Logo = styled.img`
  margin-left: 8px;
  height: 14px;
`;
